import * as React from "react";
import { Truck, Warehouse, MapPin, Briefcase } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const services = [{
  title: "POTS Line Replacement",
  description: "High-performance voice solutions featuring POTS integration and full system redundancy for mission-critical reliability.",
  icon: Truck
}, {
  title: "UCaaS Installation & Support",
  description: "AI-powered unified communications platform that streamlines voice, video, and messaging across devices, delivering intelligent call routing, real-time transcription, and predictive analytics for enhanced collaboration.",
  icon: Warehouse
}, {
  title: "Structured Cabling (Cat6, Cat6A, fiber)",
  description: "Comprehensive technical assessments and takeoffs providing GCs and MSPs with accurate field execution blueprints.",
  icon: MapPin
}, {
  title: "Network Infrastructure",
  description: "We provide rapid-response infrastructure deployment, system setup, and responsive technical support. Our hands-on field execution is specifically engineered for SMBs, MSPs, and service providers who require reliable, professional representation and immediate resolution for mission-critical infrastructure.",
  icon: Briefcase
}];
export default function ProfessionalServicesGrid() {
  return <section data-section-id="243257" id="voipenterprisesystems" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tighter text-foreground sm:text-5xl uppercase">Our Core Services</h2>
          <p className="mt-4 text-lg font-default text-muted-foreground max-w-2xl mx-auto">Explore our core offerings across communications and infrastructure.</p>
        </div>
        
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="border-l-4 border-l-secondary border-y-transparent border-r-transparent bg-card/50 backdrop-blur-md shadow-sm transition-all hover:shadow-xl hover:bg-card/80 rounded-lg">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-secondary/10">
                    <Icon className="h-6 w-6 text-secondary" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-default text-xl font-bold text-foreground tracking-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}